import styled from 'styled-components';

const DropdownButton = styled.button`
    padding: 15px 10px 0px 15px;
    background: ${props => props.active ? "#F8F8F9" : "transparent"};
    border: 0px;
    position: static;
    width: 100%;
    text-align: left;
    &:focus{
        outline: none;
    }
    white-space: nowrap;
`

export default DropdownButton;